import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Objects, Parts, Types} from "components";
import Collections from '../Collections'
import moment from "moment";
import {Button, Modal, ModalBody, ModalHeader} from "reactstrap";
import {InputAdornment, Tooltip} from "@material-ui/core";
import Notes from "@material-ui/icons/Notes";
import {isDirtySafe, setTimestamp} from "../../constants/Utilities";

/**
 *  @property {Phone_Logs_Object} state
 *  @property {object} model
 *  @property {Phone_Logs_Properties} model.properties
 *  @property {Phone_Logs_Is} model.is
 *  @property {Phone_Logs_Has} model.has
 *  @property {Call_Types_Object} call_types
 *  @property {Regions_Object} regions
 *  @property {Users_Object} users
 */
export default class PhoneLog extends Framework.Components.Object {
	constructor(props) {
		super(props, Types.Phone_Logs._name);
		this.redirect = this.props.baseUrl;
		this.state = {
			...this.state,
			selectedRegion: null,
			shouldShowSecondDay: false,
			submitting: false
		}
	}

	componentDidMount() {
		super.componentDidMount();
		if (localStorage.getItem('phoneLogData') && localStorage.getItem('phoneLogData') !== 'submitted' && localStorage.getItem('phoneLogData') !== 'blank' && localStorage.getItem('phoneLogData') !== 'cleared' && this.props.isNew) {
			let localData = JSON.parse(localStorage.getItem('phoneLogData'))
			Object.keys(localData).forEach((key) => {
				if (key !== 'shouldShowSecondDay' && key !== 'filterDate') {
					this.setState({[key]: localData[key]});
				}
			})
		} else {
			localStorage.setItem('phoneLogData', 'blank')
		}
		this.state.submitting = false;
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);
		this.state.submitting = false;
		if (localStorage.getItem('phoneLogData') === 'cleared') {
			this.setState({
				call_type: "",
				call_type_error: "",
				call_type_alt: "",
				notes: "",
				notes_error: "",
				phone_number: "",
				phone_number_error: "",
				region: "",
				region_error: "",
				region_alt: "",
				user: "",
				user_error: "",
				user_alt: "",
				zip: "",
				zip_error: "",
				call_types: "",
				regions: "",
				users: "",
				loading: false,
				loaded: true,
				binary_id: "",
				notes_error_error: ""
			})
			localStorage.setItem('phoneLogData', JSON.stringify(this.state))
		} else if (localStorage.getItem('phoneLogData') !== 'submitted' && this.props.isNew) {
			localStorage.setItem('phoneLogData', JSON.stringify(this.state))
		}
		if (typeof this.props.updateName === 'function') {
			this.props.updateName(this.state.name);
		}
		//check if something has changed and if it has then update the timestamp used for delaying the idle modal
		const isDirty = isDirtySafe(prevState, this.state, ['call_type', 'notes', 'phone_number', 'region', 'zip'])
		if (isDirty) {
			setTimestamp('lastSync')
		}
	}

	async handleSubmit(event, suppressToast = false) {

		if (this.state.submitting === true) {
			return;
		} else {
			this.state.submitting = true;
		}
		const didSubmit = await super.handleSubmit();
		if (didSubmit) {
			localStorage.setItem('phoneLogData', 'submitted')
			this.setState({submitting: false})
		} else {
			this.setState({submitting: false})
		}

		if (typeof (this.props.clearData) === 'function') {
			this.props.clearData()
		}

	}

	processPhoneString(input) {
		const regex = /^[0-9-]+$/; // Regex to allow only numbers and dashes
		if (regex.test(input)) {
			return input.replace(/-/g, ''); // Remove all dashes if valid
		}
		return ''; // Return null if the string contains invalid characters
	}

	form = () => {
		/**
		 * @param {Phone_Logs_Properties} data
		 */
		let {properties} = this.model
		/**
		 * @type {Phone_Logs_Object} object
		 */
		let object = this.state
		let {loading} = this.state

		return (
			<div className={'form-group'}>
				<div className={'row'}>
					<div className={this.props.isNew ? 'col-6' : 'col-12'}>
						<fieldset>
							<div className={'row'} style={{display: 'flex', flexDirection: 'row'}}>
								<div className={'col-11'}>
									<div className={"form-group"}>
										<Framework.Elements.PhoneNumber
											value={object.phone_number}
											error={object.phone_number_error}
											property={properties.phone_number}
											update={this.handleTextFieldPropertyUpdate}
											label={"Phone Number"}
										/>
									</div>
								</div>
								<div className={'col-1'} style={{padding: 0}}>
									<Tooltip title={'Show Possible Existing Notes'}>
										<Button
											color="blue-hoki"
											size={"sm"}
											block={true}
											onClick={() => this.setState({existingModal: true})}
											disabled={this.processPhoneString(this.state.phone_number) === ''}
										>
											<Notes fontSize={'small'}/>
										</Button>
									</Tooltip>
								</div>
							</div>
							<div className={"form-group"}>
								<Framework.Elements.Select
									shouldLoad={this.state.loaded}
									value={object.region}
									error={object.region_error}
									property={properties.region}
									update={this.handleSelectPropertyUpdate}
									label={"Region"}
									default={{value: '', label: "Select a Region"}}
									nullable={true}
									limit={null}
								/>
							</div>
							<div className={"form-group"}>
								<Framework.Elements.TextField
									value={object.notes}
									error={object.notes_error}
									property={properties.notes}
									update={this.handleTextFieldPropertyUpdate}
									label={"Information About Call"}
									multiline={8}
									disabled={false}
								/>
							</div>
							<div className={"form-group"}>
								<Framework.Elements.ZipCode
									value={object.zip}
									error={object.zip_error}
									property={properties.zip}
									update={this.handleTextFieldPropertyUpdate}
									label={"Zipcode"}
								/>
							</div>
							<div className={"form-group"}>
								<Framework.Elements.Select
									shouldLoad={this.state.loaded}
									value={object.call_type}
									error={object.call_type_error}
									property={properties.call_type}
									update={this.handleSelectPropertyUpdate}
									label={"Type of Call"}
									text={"type"}
									default={{value: '', label: "Select a Call Type"}}
									nullable={true}
								/>
							</div>
							{this.props.isNew && <div className="row">
								<div className="col">
									<Objects.RemoteAppointments
										date={this.state.filterDate}
									/>
								</div>
							</div>}

							{!this.props.isNew && <div>
								<Framework.Elements.Checkbox
									value={object.customer_contacted}
									property={properties.customer_contacted}
									error={object.customer_contacted_error}
									update={() => {
										this.setState({customer_contacted: !this.state.customer_contacted})
									}}
									color="primary"
									label={'Customer Contacted'}
								/>
							</div>}


						</fieldset>
					</div>
					{this.props.isNew && <div className={'col-6'}>
						{this.state.shouldShowWarning && <b>
							There are no appointments available before {moment(this.state.dayWarning).format('dddd MMM D')}.
						</b>}
						<Collections.FEAvailability
							history={this.props.history}
							reloadShell={this.props.reloadShell}
							reloadPage={this.refreshPage}
							reloadSelf={this.state.refresh}
							regions={this.props.regions}
							showCSV={false}
							showTotal={false}
							selectedRegion={this.state.region}
							forPhoneLog={true}
							toggleShowSecondDay={() => {
								this.setState({shouldShowSecondDay: true})
							}}
							shouldShowWarning={(filterdate) => {
								this.setState({shouldShowWarning: true, dayWarning: filterdate})
							}}
							updateDate={(date) => this.setState({filterDate: date})}
						/>
						{this.state.shouldShowSecondDay && <Collections.FEAvailability
							history={this.props.history}
							reloadShell={this.props.reloadShell}
							reloadPage={this.refreshPage}
							reloadSelf={this.state.refresh}
							regions={this.props.regions}
							showCSV={false}
							showTotal={false}
							selectedRegion={this.state.region}
							forPhoneLog={true}
							shouldAddDay={true}
						/>}
					</div>}


					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</div>

				<Modal
					isOpen={this.state.existingModal}
					toggle={() => {
						this.setState({existingModal: false})
					}}
					size={'xl'}
					backdrop={true}
				>
					<ModalHeader toggle={() => {
						this.setState({existingModal: false})
					}}>
						Previous Phone Logs
					</ModalHeader>
					<ModalBody>
						<Objects.MultiplePhoneLogs
							search={this.processPhoneString(this.state.phone_number)}
						/>
					</ModalBody>
				</Modal>
			</div>
		)
	}
}
